const mainProduct = document.querySelector(".MainProduct"),
  upsellGrid = mainProduct?.querySelector(".custom--bundle__products--section");

function waitForElement(selector, callback) {
  new MutationObserver((mutations, observerInstance) => {
    const element = document.querySelector(selector);
    element && (observerInstance.disconnect(), callback(element));
  }).observe(document.body, {
    childList: !0,
    subtree: !0,
  });
}
fetch(window.location.pathname + ".json")
  .then((response) => {
    if (!response.ok) throw new Error("Failed to retrieve product data.");
    return response.json();
  })
  .then((data) => {
    waitForElement(".cbb-frequently-bought-container", (target) => {
      const currentProductId = data.product && data.product.id;
      fetchRecommendedProducts(currentProductId, target),
        addToCartFunctionality();
    });
  })
  .catch((error) => console.error("Error fetching product data:", error));

function fetchRecommendedProducts(currentProductId, target) {
  if (!currentProductId) {
    console.error("currentProductId was not found");
    return;
  }

  const recommendedProductContainer = document.createElement("div");
  recommendedProductContainer.classList.add("custom--bundle_container");

  const productsList = document.createElement("ul");
  productsList.classList.add("custom--bundle_products_list");
  recommendedProductContainer.appendChild(productsList);

  document
    .querySelectorAll(".cbb-frequently-bought-selector-list li")
    .forEach((listItem) => {
      const input = listItem.querySelector('input[type="checkbox"]');
      if (input && !input.name.includes(currentProductId)) {
        const productId = input.name.split("_")[1],
          productLinkElement = listItem.querySelector(
            ".cbb-frequently-bought-selector-link"
          ),
          productLink = productLinkElement
            ? productLinkElement.getAttribute("href")
            : "#",
          productName =
            listItem.querySelector(".cbb-frequently-bought-selector-label-name")
              ?.innerText || "",
          productImage = target
            .querySelector(
              `.cbb-frequently-bought-product-image-link[data-href="${productLink}"]`
            )
            ?.closest("li")
            ?.querySelector(".cbb-frequently-bought-product-image")
            ?.style.backgroundImage,
          imageUrl = productImage
            ? productImage.replace(/^url\(["']?/, "").replace(/["']?\)$/, "")
            : "",
          regularPrice =
            listItem.querySelector(
              ".cbb-frequently-bought-selector-label-regular-price span"
            )?.innerHTML || "",
          salePrice =
            listItem.querySelector(
              ".cbb-frequently-bought-selector-label-sale-price span"
            )?.innerHTML || "",
          comparePrice =
            listItem.querySelector(
              ".cbb-frequently-bought-selector-label-compare-at-price span"
            )?.innerHTML || "",
          // Determine if a discount exists by checking if either salePrice or comparePrice is not blank.
          hasDiscount = salePrice.trim() !== "" || comparePrice.trim() !== "",
          productItem = document.createElement("li");

        productItem.classList.add("custom--bundle_item");
        productItem.setAttribute("data-product-id", productId);

        // Build the price block based on our conditions.
        let priceBlock = "";
        if (hasDiscount) {
          // If discount exists, show regular price and the sale/compare price.
          priceBlock = `
          <span class="custom--bundle_discounted_price custom--Price">
            ${comparePrice}
          </span>
          <span class="custom--bundle_sale_price custom--Price"> ${
            salePrice.trim() !== "" ? salePrice : comparePrice
          }</span>
        `;
        } else {
          // Otherwise, show only the regular price.
          priceBlock = `<span class="custom--bundle_regular_price custom--Price">${regularPrice}</span>`;
        }

        productItem.innerHTML = `
        <input type="checkbox" class="custom--bundle_input" id="${
          input.id
        }" name="${input.name}">
        <a href="${productLink}" class="custom--bundle_img">
          <img src="${imageUrl}" class="media" alt="${productName}">
        </a>
        <div class="custom--bundle_product-info">
          <div class="custom--bundle_title-wrapp">
            <a href="${productLink}" class="custom--bundle_name">${productName}</a>
            <div class="custom--bundle_price_wrapp ${
              hasDiscount ? "acc_price_discounted" : ""
            }">
              ${priceBlock}
            </div>
            <div class="custom--bundle_rating" id="rating-${productId}"></div>
          </div>
        </div>
      `;

        productsList.appendChild(productItem);

        // Call the function to load reviews.
        getReviews(
          productId,
          input.id,
          productItem.querySelector(`#rating-${productId}`)
        );
      }
    });

  upsellGrid.appendChild(recommendedProductContainer);
  upsellGrid.closest('[data-upsell-wrap]').classList.remove("hidden");
}

function getReviews(productId, itemID, titleWrapper) {
  const url = `https://loox.io/widget/4klRfJu5sK/ratings?products_ids=${productId}&.js`;
  fetch(url)
    .then((response) => {
      if (!response.ok)
        throw new Error(`Failed to fetch reviews: ${response.statusText}`);
      return response.json();
    })
    .then((data) => {
      if (data.ratings && data.ratings.length > 0) {
        const rating = data.ratings[0].rating,
          raters = data.ratings[0].raters,
          ratingContainer = document.createElement("div");
        ratingContainer.classList.add("custom--rating-container");
        const starsContainer = document.createElement("div");
        starsContainer.classList.add("rating-stars"),
          starsContainer.style.setProperty("--product-rating", rating);
        const ratersContainer = document.createElement("div");
        ratersContainer.classList.add("raters"),
          (ratersContainer.innerText = `(${raters})`),
          ratingContainer.appendChild(starsContainer),
          ratingContainer.appendChild(ratersContainer),
          titleWrapper.appendChild(ratingContainer);
      } else console.warn("No reviews found for this product");
    })
    .catch((error) => {
      console.error("Error fetching reviews:", error);
    });
}

function addToCartFunctionality() {
  document.querySelectorAll(".custom--bundle_input").forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      attachATCHandler();
    });
  }),
    attachATCHandler();
}

function attachATCHandler() {
  document.querySelectorAll(".Product-form__submit").forEach((atcButton) => {
    const newATCButton = atcButton.cloneNode(!0);
    atcButton.parentNode.replaceChild(newATCButton, atcButton),
      newATCButton.addEventListener("click", async function (event) {
        event.preventDefault(), event.stopPropagation();
        const mainProductInput = document.querySelector(
          '.ProductForm input[name="id"]'
        );
        if (!mainProductInput) {
          console.error("The main product was not found.");
          return;
        }
        const mainProductId = mainProductInput.value,
          recommendedProducts = [];
        document
          .querySelectorAll(".custom--bundle_input:checked")
          .forEach((checkbox) => {
            const productId = checkbox.id,
              priceWrapper = checkbox
                .closest(".custom--bundle_item")
                .querySelector(".custom--bundle_discounted_price"),
              discountedPrice = priceWrapper
                ? parseFloat(
                    priceWrapper.textContent.replace("\u20AC", "").trim()
                  )
                : null;
            productId &&
              recommendedProducts.push({
                id: productId,
                quantity: 1,
                properties: discountedPrice
                  ? {
                      custom_price: discountedPrice.toFixed(2),
                    }
                  : {},
              });
          });
        const productsToAdd = [
          {
            id: mainProductId,
            quantity: 1,
          },
          ...recommendedProducts,
        ];
        if (productsToAdd.length > 0)
          try {
            const response = await fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                items: productsToAdd,
              }),
            });
            if (!response.ok)
              throw new Error(
                `Error while adding to the cart: ${response.status}`
              );
            await fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"cart?section_id=cart-drawer")
              .then((response2) => response2.text())
              .then((data) => {
                const id = "CartDrawerForm",
                  html = new DOMParser().parseFromString(data, "text/html"),
                  destination = document.getElementById(id),
                  source = html.getElementById(id);
                source &&
                  destination &&
                  (destination.innerHTML = source.innerHTML),
                  document.dispatchEvent(new CustomEvent("cartdrawer:refresh")),
                  document.dispatchEvent(new CustomEvent("cart:refresh")),
                  document.dispatchEvent(new CustomEvent("cart:open")),
                  attachATCHandler();
              })
              .catch((error) => {
                console.error("Error while refreshing the cart drawer:", error);
              });
          } catch (error) {
            console.error("Error while adding to the cart:", error);
          }
        else console.warn("There are no products to add to the cart.");
      });
  });
}
